(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('countdown-timer')) {
    customElements.define(
      'countdown-timer',
      class CountdownTimer extends HTMLElement {
        connectedCallback() {
          this.targetMs = Number(this.dataset.target) * 1000;
          this.unitsEl = this.querySelector('[data-countdown-units]');
          this.expiredEl = this.querySelector('[data-countdown-expired]');
          this.values = {
            days: this.querySelector('[data-unit="days"]'),
            hours: this.querySelector('[data-unit="hours"]'),
            minutes: this.querySelector('[data-unit="minutes"]'),
            seconds: this.querySelector('[data-unit="seconds"]'),
          };

          if (!this.targetMs) {
            this.showExpired();
            return;
          }

          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        showExpired() {
          clearInterval(this.timer);
          if (this.unitsEl) this.unitsEl.hidden = true;
          if (this.expiredEl) this.expiredEl.hidden = false;
        }

        tick() {
          const remaining = Math.floor((this.targetMs - Date.now()) / 1000);

          if (remaining <= 0) {
            this.showExpired();
            return;
          }

          const pad = (n) => String(n).padStart(2, '0');
          this.values.days.textContent = Math.floor(remaining / 86400);
          this.values.hours.textContent = pad(Math.floor((remaining % 86400) / 3600));
          this.values.minutes.textContent = pad(Math.floor((remaining % 3600) / 60));
          this.values.seconds.textContent = pad(remaining % 60);

          if (this.unitsEl) this.unitsEl.hidden = false;
          if (this.expiredEl) this.expiredEl.hidden = true;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
